import View from 'client/components/common/BuildingBlocks/FloatBelow/FloatBelow';
import model from 'client/components/common/BuildingBlocks/FloatBelow/model';

export const FLOAT_BELOW = () => ({
	view: View,
	get model() {
		return model();
	},
});
